import { render } from "./UserPage.vue?vue&type=template&id=4b929a98&scoped=true&ts=true"
import script from "./UserPage.vue?vue&type=script&lang=ts"
export * from "./UserPage.vue?vue&type=script&lang=ts"

import "./UserPage.vue?vue&type=style&index=0&id=4b929a98&scoped=true&lang=css"

import exportComponent from "/usr/src/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b929a98"]])

export default __exports__